import ULThemeSubtitle from "@/components/ULThemeSubtitle";
import ULThemeTitle from "@/components/ULThemeTitle";
import { translate } from "@/utils/helpers/localeTranslate";

import { useEmailIdentifierChallengeManager } from "../hooks/useEmailIdentifierChallengeManager";

function Header() {
  const { data, locales } = useEmailIdentifierChallengeManager();

  // The wordmark lives in JourneyLayout's left column now (light-theme
  // redesign) — this screen no longer renders its own logo.
  const email = data?.email || locales?.header?.emailFallback;
  const description = translate("header.description", { email }, locales);

  return (
    <>
      <ULThemeTitle>{locales?.header?.title}</ULThemeTitle>
      <ULThemeSubtitle className="mb-1">{description}</ULThemeSubtitle>
      <p className="text-xs mb-6" style={{ color: "#6B7280" }}>
        {locales?.header?.expiry}
      </p>
    </>
  );
}

export default Header;
